import { render, staticRenderFns } from "./YoutubeLinks.vue?vue&type=template&id=02914173"
import script from "./YoutubeLinks.vue?vue&type=script&lang=ts"
export * from "./YoutubeLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports